import { API as RestAPI } from "aws-amplify";
import { APIResponse, toDefaultRequestPayload } from "./common";

export interface PublishPageInput {
    pageId: string;
    instanceId: string;
}

export interface PublishPageOutput {
    success: boolean;
    message: string;
}

export interface ContentBusAPI {
    publishPage(input: PublishPageInput): Promise<APIResponse<PublishPageOutput>>;
}

export function createContentBusAPI(): ContentBusAPI {
    return {
        publishPage: async (input: PublishPageInput): Promise<APIResponse<PublishPageOutput>> => {
            const response: APIResponse<PublishPageOutput> = await RestAPI.post(
                "custom-domain",
                "/content-bus/publish-page",
                toDefaultRequestPayload(input)
            );
            return response;
        }
    };
}
